import React from "react"

function Lightbulb({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg width={width} height={height} viewBox="6 6 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.6775 10.2347C15.1701 10.0959 13.6762 11.7423 13.9109 14.5077"
        stroke="#003E4C"
        strokeWidth="0.998148"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.7592 23.5659H20.1317"
        stroke="#003E4C"
        strokeWidth="0.995883"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7592 25.7998H20.1317"
        stroke="#003E4C"
        strokeWidth="0.995883"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3275 27.2246C16.4395 29.3357 18.995 28.9273 19.0324 27.2246"
        stroke="#003E4C"
        strokeWidth="0.998148"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.8126 21.6761C14.3751 20.0082 13.6069 18.3699 12.4812 16.762C11.4355 15.2802 11.1581 13.3905 11.7289 11.6701C12.4919 9.27819 14.6418 7.52353 17.6775 7.34131"
        stroke="#003E4C"
        strokeWidth="0.998148"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M20.5475 21.6768C20.985 20.0089 21.7532 18.3706 22.8789 16.7627C23.9246 15.2809 24.202 13.3911 23.6312 11.6708C22.8682 9.27889 20.7182 7.52422 17.6825 7.342"
        stroke="#003E4C"
        strokeWidth="0.998148"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}
export default Lightbulb
